import React from "react";
import { Outlet } from "react-router-dom";
const reviewComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default reviewComponent
